<template>
  <div v-if="isPhoneBool && buttonlist.length > 0" class="mobile-routerbtns-container"
    :class="isInverted ? 'left' : 'right'">
    <v-btn v-if="buttonlist.length > 2" @click="open = !open" :color="open ? 'error' : 'primary'" :outlined="open" dark
      fab class="mobile-actionbtn" style="z-index: 2;">
      <v-icon v-text="open ? 'mdi-close' : 'mdi-menu'" :size="30" />
    </v-btn>
    <component v-for="(button, index) in buttonlist" :key="button" :is="button" class="mobile-actionbtn"
      :style="'bottom:' + (open ? ((index + 1) * 60) : 0) + 'px;'" :index="index" />
  </div>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import ApproveJobBtn from "@/components/Buttons/ApproveJobBtn.vue";
import ArticlePickerBtn from "@/components/Buttons/ArticlePickerBtn.vue";
import CancelNewJobBtn from "@/components/Buttons/CancelNewJobBtn.vue";
import CompleteJobBtn from "@/components/Buttons/CompleteJobBtn.vue";
import CopyJobBtn from "@/components/Buttons/CopyJobBtn.vue";
import CreateJobBtn from "@/components/Buttons/CreateJobBtn.vue";
import DeleteJobBtn from "@/components/Buttons/DeleteJobBtn.vue";
import HazardAnalysisBtn from "@/components/Buttons/HazardAnalysisBtn.vue";
import ImportMachineBtn from "@/components/Buttons/ImportMachineBtn.vue";
import NewAccountBtn from "@/components/Buttons/NewAccountBtn.vue";
import NewAppointmentBtn from "@/components/Buttons/NewAppointmentBtn.vue";
import NewAssetTypeBtn from "@/components/Buttons/NewAssetTypeBtn.vue";
import NewCustomerBtn from "@/components/Buttons/NewCustomerBtn.vue";
import NewCustomerGroupBtn from "@/components/Buttons/NewCustomerGroupBtn.vue";
import NewDialogTriggerBtn from "@/components/Buttons/NewDialogTriggerBtn.vue";
import NewEntityBtn from "@/components/Buttons/NewEntityBtn.vue";
import NewJobBtn from "@/components/Buttons/NewJobBtn.vue";
import NewLeadBtn from "@/components/Buttons/NewLeadBtn.vue";
import NewLeadTypeBtn from "@/components/Buttons/NewLeadTypeBtn.vue";
import NewLoggBtn from "@/components/Buttons/NewLoggBtn.vue";
import NewSupplierBtn from "@/components/Buttons/NewSupplierBtn.vue";
import NewSupplierFailureCodeBtn from "@/components/Buttons/NewSupplierFailureCodeBtn.vue";
import NonAlfaBtn from "@/components/Buttons/NonAlfaBtn.vue";
import OldPageNewEntityBtn from "@/components/Buttons/OldPageNewEntityBtn.vue";
import ServiceReportBtn from "@/components/Buttons/ServiceReportBtn.vue";
import ToggleCustomerActiveBtn from "@/components/Buttons/ToggleCustomerActiveBtn.vue";
import ToggleJobCategoryActiveBtn from "@/components/Buttons/ToggleJobCategoryActiveBtn.vue";
import ToggleMachineActiveBtn from "@/components/Buttons/ToggleMachineActiveBtn.vue";
import TogglePublicViewBtn from "@/components/Buttons/TogglePublicViewBtn.vue";
import TransferAllMachinesBtn from "@/components/Buttons/TransferAllMachinesBtn.vue";
import UploadFileBtn from "@/components/Buttons/UploadFileBtn.vue";

export default {
  name: "MobileRouterButtons",
  props: {},
  components: {
    ApproveJobBtn,
    CompleteJobBtn,
    CancelNewJobBtn,
    CopyJobBtn,
    CreateJobBtn,
    DeleteJobBtn,
    HazardAnalysisBtn,
    NewAppointmentBtn,
    NewCustomerGroupBtn,
    NewSupplierBtn,
    NewJobBtn,
    NewEntityBtn,
    NewAccountBtn,
    NewCustomerBtn,
    NewLoggBtn,
    NewDialogTriggerBtn,
    NewAssetTypeBtn,
    NewLeadBtn,
    NewLeadTypeBtn,
    NewSupplierFailureCodeBtn,
    NonAlfaBtn,
    ServiceReportBtn,
    UploadFileBtn,
    ImportMachineBtn,
    ToggleCustomerActiveBtn,
    ToggleMachineActiveBtn,
    ToggleJobCategoryActiveBtn,
    TogglePublicViewBtn,
    OldPageNewEntityBtn,
    TransferAllMachinesBtn,
    ArticlePickerBtn,
  },
  mixins: [clientAPI],

  data() {
    return {
      open: false,
    };
  },

  created() { },

  mounted() { },

  methods: {},

  computed: {
    buttonlist() {
      return this.$route?.meta?.overrides?.header?.buttons ?? [];
    },

    isInverted() {
      return this.$store.getters["prefrences/Prefrence"]("InvertedMobileRouterbtns");
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
.mobile-routerbtns-container {
  position: fixed;
  bottom: 40px;
  z-index: 1;
  width: 56px;
  height: 56px;
}

.mobile-routerbtns-container.left {
  left: 10px;
}

.mobile-routerbtns-container.right {
  right: 10px;
}

.mobile-actionbtn {
  position: absolute;
  -webkit-transition: all 0.15s ease-out;
  -o-transition: all 0.15s ease-out;
  -moz-transition: all 0.15s ease-out;
  transition: all 0.15s ease-out;
}
</style>
